import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PrimeNG } from 'primeng/config';
import { I18nService } from './core/services/i18n.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  template: `<router-outlet />`,
})
export class AppComponent {
  title = 'sps-ui-template';

  constructor(private primeng: PrimeNG, private i18n: I18nService) {
    // Clickjacking prevention (ergänzend zu den Headern!)
    try {
      if (window.top && window.self !== window.top) {
        window.top.location.href = window.self.location.href;
      }
    } catch {
      // Fallback: hide own site
      document.body.style.display = 'none';
    }
    primeng.ripple.set(true);
    this.i18n.initPrimengTranslation('de');
    this.i18n.initLanguageData('de');
    this.i18n.initCountryList();
  }
}
